;
var myaNameSpace = myaNameSpace || {};
myaNameSpace.audSeg = myaNameSpace.audSeg || {};
(function (audSegArg) {

    const getIsLoggedIn = function (audSegArg2) {
        fetch('/candidate-auth/whoami')
            .then(function (response) { return response.json() })
            .then(function (data) {
                audSegArg2.loggedIn = (data != null && data.hasOwnProperty('result') && data.result.hasOwnProperty('loggedInState') && data.result.loggedInState > 0);
            })
            .catch(function () { console.log("audience segmentation error") });
    }

    const isDesktop = function () { return (window.matchMedia("(min-width: 767px)").matches); }

    const getJobId = function (audSegArg2) {
        if (document.readyState == "complete") {
            jobId(audSegArg2);
        }
        else {
            document.addEventListener("DOMContentLoaded", function (event) {
                jobId(audSegArg2);
            });
        }
    }

    const jobId = function (audSegArg2) {
        const elem = document.getElementById("jobId");
        try {
            audSegArg2.jobId = (elem) ? parseInt(elem.value) : 0;
        }
        catch (err) {
            audSegArg2.jobId = 0;
        }
    }

    audSegArg.isDesktop = isDesktop();
    getIsLoggedIn(audSegArg);
    getJobId(audSegArg);

})(myaNameSpace.audSeg);
